// Mirror of the C++ common::transport::ReconnectStrategy. Pure: no
// timer, no clock — callers decide when to advance.

export interface ReconnectOptions {
  initialMs?: number;
  maxMs?: number;
  multiplier?: number;
}

export class ReconnectStrategy {
  private current: number;
  private attempts = 0;

  constructor(private readonly opts: Required<ReconnectOptions> = defaults()) {
    this.current = opts.initialMs;
  }

  nextDelayMs(): number {
    const d = this.current;
    this.attempts += 1;
    const next = Math.min(this.opts.maxMs, this.current * this.opts.multiplier);
    this.current = next;
    return d;
  }

  reset(): void {
    this.current = this.opts.initialMs;
    this.attempts = 0;
  }

  attemptCount(): number {
    return this.attempts;
  }
}

function defaults(): Required<ReconnectOptions> {
  return { initialMs: 500, maxMs: 30_000, multiplier: 2.0 };
}

export function withDefaults(o?: ReconnectOptions): Required<ReconnectOptions> {
  return { ...defaults(), ...o };
}
